import styledC, { css } from 'styled-components';

import {
  CombinedTheme,
  SearchFieldDesignTokens,
} from '@adsk/alloy-react-styles';

/**
 * Styled components for SearchField right adornment area.
 * Includes inline text display and container for right-side elements.
 */

type RightAdornmentTextProps = {
  $tokens?: CombinedTheme['tokens'];
};

export const RightAdornmentText = styledC.span<RightAdornmentTextProps>`

${({ $tokens }) => {
  const { fontFamily, fontSize, fontWeight, lineHeight } =
    $tokens?.component?.typography?.bodySmall || {};
  return css`
    font-family: ${fontFamily};
    font-weight: ${fontWeight};
    font-size: ${fontSize};
    line-height: ${lineHeight};
    color: ${$tokens?.generic?.color?.charcoal?.[700]?.[100]};
  `;
}}
  pointer-events: none;
`;

type RightAdornmentContainerProps = {
  $tokens?: SearchFieldDesignTokens;
};

export const RightAdornmentContainer = styledC.div<RightAdornmentContainerProps>`
  height: 36px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  gap: ${({ $tokens }) => $tokens?.rightAdornment?.gap};
`;
